import { lazy } from 'react';
// project import
import Loadable from '../../components/Loadable';
import DroneService from 'services/drone/DroneService';
import { Drone } from 'models/drone/Drone';
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - DASHBOARD ||============================== //

// render - dashboard
const Dashboard = Loadable(
    lazy(() => import('../../pages/dashboard/DashboardPage')),
);

// render - flight-indicators
const FlightIndicators = Loadable(
    lazy(() => import('../../pages/flight-indicators/FlightIndicatorsPage')),
);

// render - flight-indicators-tablet
const FlightIndicatorsTablet = Loadable(
    lazy(() =>
        import(
            '../../pages/flight-indicators-tablet/FlightIndicatorsTabletPage'
        ),
    ),
);

const dashboard = {
    path: 'drones',
    children: [
        {
            element: (
                // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
                <Dashboard />
                // </RequireAuthorizedAccess>
            ),
            children: [
                {
                    index: true,
                },
                {
                    path: 'manage-laptop/:id',
                    element: (
                        <FlightIndicators
                            navigateTo={'/drones'}
                            service={DroneService}
                            pageTitle="Drone"
                            entity={Drone}
                            slice={'drone'}
                        />
                    ),
                },
                {
                    path: 'manage-tablet/:id',
                    element: (
                        <FlightIndicatorsTablet
                            navigateTo={'/drones'}
                            service={DroneService}
                            pageTitle="Drone"
                            entity={Drone}
                            slice={'drone'}
                        />
                    ),
                },
            ],
        },
    ],
};

export default dashboard;
